import { useCallback, useEffect, useState } from 'react';

import Communicator from '../helpers/communication-adapter';
import { CommunicationMessageTypes } from '../helpers/constants';
import { IMonitorInitSync } from '../types/communicator-types';
import useCommunicator from './useCommunicator';

export default function useReportMonitorReady() {
  const communicator = useCommunicator<IMonitorInitSync>(
    CommunicationMessageTypes.MonitorInitConfig
  );
  const [buffer, setBuffer] = useState<Array<string>>([]);
  useEffect(() => {
    if (Communicator.isReady && communicator) {
      console.log('CMA will send ready', buffer, communicator);
      buffer.forEach((item) => {
        communicator.postMessage({
          monitor: item,
          state: 'ready',
        });
      });
      if (buffer.length > 0) {
        setBuffer([]);
      }
    }
  }, [buffer, communicator]);

  const addToBuffer = (message: string) => setBuffer([...buffer, message]);

  return addToBuffer;
}
